import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { activateAccount } from '../../services/otpService';
import './Activate.css';

const Activate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const activate = async () => {
      const token = searchParams.get('token');
      const email = searchParams.get('email');

      console.log('🔗 Activation Link Opened');
      console.log('  Token:', token ? token.substring(0, 8) + '...' : 'Missing');
      console.log('  Email:', email || 'Missing');

      // Validate parameters
      if (!token || !email) {
        setStatus('error');
        setError('Invalid activation link. Missing token or email.');
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setStatus('error');
        setError('Invalid email address in activation link.');
        return;
      }

      try {
        console.log('🔄 Starting account activation...');
        const result = await activateAccount(email, token);

        if (result.success) {
          setStatus('success');
          setMessage(result.message || 'Account activated successfully!');
          console.log('✅ Activation successful');
          
          // Redirect to donate page after 3 seconds
          setTimeout(() => {
            navigate('/donate-anonymously');
          }, 3000);
        } else {
          setStatus('error');
          const errorMsg = result.error || 'Failed to activate account. Please try again.';
          
          // Check if it's a Firestore offline error
          if (errorMsg.includes('offline') || errorMsg.includes('blocked')) {
            setError(
              'Firestore is offline or blocked. ' +
              'Please disable ad blockers or browser extensions that might be blocking Firestore, ' +
              'then try again. If the problem persists, request a new activation email.'
            );
          } else {
            setError(errorMsg);
          }
          
          console.error('❌ Activation failed:', result.error);
        }
      } catch (err: any) {
        setStatus('error');
        setError(err.message || 'An unexpected error occurred. Please try again.');
        console.error('❌ Activation error:', err);
      }
    };

    activate();
  }, [searchParams, navigate]);

  return (
    <div className="activate-page">
      <div className="activate-container">
        {status === 'loading' && (
          <div className="activate-status loading">
            <div className="status-icon loading-spinner">⏳</div>
            <h2>Activating Your Account...</h2>
            <p>Please wait while we activate your account.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="activate-status success">
            <div className="status-icon success-icon">✓</div>
            <h2>Account Activated Successfully!</h2>
            <p>{message}</p>
            <p className="redirect-message">Redirecting to donation page...</p>
            <button 
              className="btn-go-to-donate"
              onClick={() => navigate('/donate-anonymously')}
            >
              Go to Donate Now
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="activate-status error">
            <div className="status-icon error-icon">✗</div>
            <h2>Activation Failed</h2>
            <p className="error-message">{error}</p>
            <div className="error-actions">
              <button 
                className="btn-request-new"
                onClick={() => navigate('/donate-anonymously')}
              >
                Request New Activation Email
              </button>
              <button 
                className="btn-go-home"
                onClick={() => navigate('/')}
              >
                Go to Home
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Activate;

